











































import {Component} from 'vue-property-decorator';
import DoughnutChart from '../chartjs/DoughnutChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import ChartLabels from '../ChartLabels.vue';
import { ReportType } from '../../models/reportType';
import BaseFlowReport from '@/features/reports/components/flows/baseFlowReport';
import TotalsDoughnutChart from './TotalsDoughnutChart.vue';
import {Data, DateGrouping, Series} from '@/features/reports/models';
import {FluentDate} from '@/features/reports/services';

@Component({
	components: {
		DoughnutChart,
		LoadingSpinner,
		ChartError,
		ChartLabels,
		TotalsDoughnutChart
	}
})
export default class FlowTotalsCharts extends BaseFlowReport {
	public reportId = ReportType.FLOW_TOTALS;

	public dataPointGrouping(): DateGrouping {
		const filterRange = this.selectedDateOption.getDateRange();

		if (new FluentDate(filterRange.start).isStartOfMonth() && new FluentDate(filterRange.end).isEndOfMonth()) {
			return DateGrouping.MONTH;
		}

		return DateGrouping.DAY;
	}

	public getFlowIdForRequest(): string {
		return 'all';
	}
}
